import { render, staticRenderFns } from "./SupportedMedia.vue?vue&type=template&id=0ab00072&"
import script from "./SupportedMedia.vue?vue&type=script&lang=js&"
export * from "./SupportedMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports